export default "__VITE_ASSET__DqPY1cz2__"